import { findByIndexOrProperty } from 'utilsTS/array';
import { SecondaryNavigationHeadingItemProps, SecondaryNavigationItemProps } from './components';

export const isItemSelected = (
    items: (SecondaryNavigationItemProps | SecondaryNavigationHeadingItemProps)[],
    item: SecondaryNavigationItemProps | SecondaryNavigationHeadingItemProps,
    selectedItemFromProps?:
        | string
        | number
        | SecondaryNavigationItemProps
        | SecondaryNavigationHeadingItemProps,
) => {
    const selected = findByIndexOrProperty<
        SecondaryNavigationItemProps | SecondaryNavigationHeadingItemProps
    >([...items, item], selectedItemFromProps, 'href');
    return item.selected || item === selected;
};

export const determineOpenItem = (
    items: (SecondaryNavigationItemProps | SecondaryNavigationHeadingItemProps)[],
    selectedItemFromProps?:
        | string
        | number
        | SecondaryNavigationItemProps
        | SecondaryNavigationHeadingItemProps,
) =>
    items.findIndex((item) => {
        // only SecondaryNavigationHeadingItem type has isOpen
        const itemIsOpen = 'isOpen' in item ? item.isOpen : false;

        if (item.selected || itemIsOpen) {
            return true;
        }

        if (item.items && item.items.some((subItem) => subItem.selected)) {
            return true;
        }

        if (selectedItemFromProps && isItemSelected(items, item, selectedItemFromProps)) {
            return true;
        }

        return false;
    });
